import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";
import utils from "../../utils";
import "./TimezoneBadge.css";

const TimezoneBadge = ({ localTime }) => {
    return (
        <div className="timezone-section">
            <Badge className="timezone-badge">
                <span className="timezone-icon">🕐</span>
                <span className="timezone-text">{utils.getTimezone(localTime)}</span>
            </Badge>
        </div>
    );
};

TimezoneBadge.propTypes = {
    localTime: PropTypes.bool,
};

export default TimezoneBadge;